import { IDangKyHoActionTypes } from './../../action-types/dang-ky-ho/IDangKyHoActionTypes';
import { IDangKyHoReducer, IDangKyHoSinhVienReducer } from "../../reducer-model/dang-ky-ho/IDangKyHoReducer";
import { v4 as uuidv4 } from "uuid";
import { eReducerStatusBase } from '../../reducer-model/eReducerStatusBase';

const iniTab: IDangKyHoSinhVienReducer = {
    id: uuidv4(),
    title: "Untitled",
    status: eReducerStatusBase.is_not_initialization,
    danhSachLopTinChis: [],
    lopTinChis: []
};
const iniState: IDangKyHoReducer = {
    selectedId: iniTab.id,
    sinhViens: [iniTab],
    requestBase: {
        nam_hoc: "",
        hoc_ky: 0,
        id_sv: "",
        ky_dang_ky: 0,
        is_nganh2: false
    },
    filter: {
        hinh_thuc_dang_ky: 0
    }
};
export const dangKyHoReducer = (state: IDangKyHoReducer = iniState, action: IDangKyHoActionTypes): IDangKyHoReducer => {
    switch (action.type) {
        case 'DANG_KY_HO_ADD_NEW_TAB':
            const id = uuidv4();
            return {
                ...state,
                selectedId: id,
                sinhViens: [{
                    ...iniTab,
                    title: action.payload?.ho_ten ?? "Untitled",
                    id: id,
                    sinhVien: action.payload

                }, ...state.sinhViens],
            };
        case 'DANG_KY_HO_REMOVE_TAB':
            return {
                ...state,
                sinhViens: state.sinhViens.filter((t) => t.id !== action.payload),
            };
        case 'DANG_KY_HO_UPDATE_TAB_DATA':
            return {
                ...state,
                sinhViens: state.sinhViens.map((t) => {
                    if (t.id === action.payload.id) {
                        return action.payload;
                    }
                    return t;
                }),
            };
        case 'DANG_KY_HO_CHANGEG_SELECTED_TAB':
            return {
                ...state,
                selectedId: action.payload,
            };
        case 'DANG_KY_HO_CHANGE_REQUEST_BASE':
            return {
                ...state,
                requestBase: action.payload,
            };
        case 'DANG_KY_HO_LOAD_LOPTINCHI_SINHVIEN_START':
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            status: eReducerStatusBase.is_loading
                        }
                    }
                    return sv;
                })
            };
        case 'DANG_KY_HO_LOAD_LOPTINCHI_SINHVIEN_SUCCESS':
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            status: eReducerStatusBase.is_completed,
                            lopTinChis: action.payload.data.lopTinChis,
                            danhSachLopTinChis: action.payload.data.dangKys
                        }
                    }
                    return sv;
                })
            };
        case 'DANG_KY_HO_LOAD_LOPTINCHI_SINHVIEN_ERROR':
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return sv;
                })
            };
        case 'DANG_KY_HO_LOAD_DANGKY_SINHVIEN_START':
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            status: eReducerStatusBase.is_loading
                        }
                    }
                    return sv;
                })
            };
        case 'DANG_KY_HO_LOAD_DANGKY_SINHVIEN_SUCCESS':
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            status: eReducerStatusBase.is_completed,
                            danhSachLopTinChis: action.payload.data
                        }
                    }
                    return sv;
                })
            };
        case 'DANG_KY_HO_LOAD_DANGKY_SINHVIEN_ERROR':
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return sv;
                })
            };
        case 'DANG_KY_HO_DANGKY_SINHVIEN_START':
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            status: eReducerStatusBase.is_saving
                        }
                    }
                    return sv;
                })
            };
        case 'DANG_KY_HO_DANGKY_SINHVIEN_SUCCESS':
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            danhSachLopTinChis: [...sv.danhSachLopTinChis, {
                                ...action.payload.data,
                                suKiens: sv.lopTinChis.find(x => x.id_lop_tc === action.payload.data.id_lop_tc)?.suKiens ?? []
                            }],
                            lopTinChis: sv.lopTinChis.map(ltc => {
                                if (ltc.id_lop_tc === action.payload.data.id_lop_tc) {
                                    return { ...ltc, so_sv_dang_ky: (ltc.so_sv_dang_ky ?? 0) + 1 };
                                }
                                return ltc;
                            }),
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return sv;
                })
            };
        case 'DANG_KY_HO_DANGKY_SINHVIEN_ERROR':
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return sv;
                })
            };
        case 'DANG_KY_HO_HUY_DANGKY_SINHVIEN_START':
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            status: eReducerStatusBase.is_deleting
                        }
                    }
                    return sv;
                })
            };
        case 'DANG_KY_HO_HUY_DANGKY_SINHVIEN_SUCCESS':
            const huyItem = state.sinhViens.find(sv => sv.id === action.payload.id)
                ?.danhSachLopTinChis.find(x => x.id === action.payload.data);
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            danhSachLopTinChis: sv.danhSachLopTinChis.filter(x => x.id !== action.payload.data),
                            lopTinChis: sv.lopTinChis.map(ltc => {
                                if (huyItem && ltc.id_lop_tc === huyItem.id_lop_tc) {
                                    return { ...ltc, so_sv_dang_ky: Math.max((ltc.so_sv_dang_ky ?? 0) - 1, 0) };
                                }
                                return ltc;
                            }),
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return sv;
                })
            };
        case 'DANG_KY_HO_HUY_DANGKY_SINHVIEN_ERROR':
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return sv;
                })
            };
        case 'DANG_KY_HO_CHANGE_FILTER':
            return {
                ...state,
                filter: action.payload
            };
        case 'DANG_KY_HO_RUT_HOCPHAN_SINHVIEN_START':
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            status: eReducerStatusBase.is_deleting
                        }
                    }
                    return sv;
                })
            };  
        case 'DANG_KY_HO_RUT_HOCPHAN_SINHVIEN_SUCCESS':
            const rutItem = state.sinhViens.find(sv => sv.id === action.payload.id)
                ?.danhSachLopTinChis.find(x => x.id === action.payload.data);
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            danhSachLopTinChis: sv.danhSachLopTinChis.map(x => {
                                if (x.id === action.payload.data) {
                                    return { ...x, rut_bot_hoc_phan: true };
                                }
                                return x;
                            }),
                            lopTinChis: sv.lopTinChis.map(ltc => {
                                if (rutItem && ltc.id_lop_tc === rutItem.id_lop_tc) {
                                    return { ...ltc, so_sv_dang_ky: Math.max((ltc.so_sv_dang_ky ?? 0) - 1, 0) };
                                }
                                return ltc;
                            }),
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return sv;
                })
            };
        case 'DANG_KY_HO_RUT_HOCPHAN_SINHVIEN_ERROR':
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            status: eReducerStatusBase.is_completed
                        }
                    }
                    return sv;
                })
            };
        case 'DANG_KY_HO_CAPNHAT_CHUYENNGANH2_SUCCESS':
            return {
                ...state,
                sinhViens: state.sinhViens.map(sv => {
                    if (sv.id === action.payload.id) {
                        return {
                            ...sv,
                            danhSachLopTinChis: sv.danhSachLopTinChis.map(x => {
                                if (x.id === action.payload.data.id) {
                                    return { ...x, chuyen_nganh2: action.payload.data.chuyen_nganh2 };
                                }
                                return x;
                            })
                        }
                    }
                    return sv;
                })
            };
        default:
            return state;
    }
}